module.exports = "/currency/assets/7a56a9ebb90544ae4131d659e0c1555d.png";